import {Inject, Injectable, Optional, PLATFORM_ID} from '@angular/core';
import {ApiService} from "./api.service";
import {Router} from "@angular/router";
import {Redirect} from "../models/Redirect/Redirect";
import {RedirectResult} from "../models/Redirect/RedirectResult";
import {WordpressService} from "./wordpress.service";
import {RESPONSE} from "../tokens/response.token";
import {isPlatformBrowser, isPlatformServer} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class RedirectionService {
  redirections? : Redirect[];
  constructor(public api : ApiService, private router: Router, private wp: WordpressService,@Inject(PLATFORM_ID) private platformId: Object, @Optional() @Inject(RESPONSE) private response: any) { }

  redirect(url :string) {
    return new Promise((resolve, reject)=> {
      if (url.endsWith("/")) {
        url = url.slice(0, -1);
      }
      if (url.includes('/fr/')) {
        url = url.replace("/fr/","/");
        this.set301(url);
        resolve(true);
        return;
      }
      if (url.includes('/en/')) {
        url = url.replace("/en/","/");
        this.set301(url);
        resolve(true);
        return;
      }
      if(url.includes('/noesit/!/')){
        url = url.replace("/noesit/!/","/");
        this.set301(url);
        resolve(true);
      }
      if(url.endsWith("/fr")){
        this.set301('/');
        resolve(true);
        return;
      }
      if(url.endsWith("/en")){
        this.set301('/');
        resolve(true);
        return;
      }
      if (this.redirections) {
          const nurl = this.redirections.find(
            (r)=>{
              if (r.match_url.endsWith("/")) {
                r.match_url = r.match_url.slice(0, -1);
              }
              return r.match_url == url || r.match_url == url+'/';
            }
        );
        if(nurl && nurl.action_data?.url){
          this.set301(nurl.action_data.url);
          resolve(true);
        } else {
          reject()
        }
      }
    });
  }

  set301(url:string){
    if (isPlatformBrowser(this.platformId) && this.response) {
      this.response.redirect(301, url);
      this.response.end();
    }else {
      this.router.navigate([url]);
    }

  }
  async getRedirects(): Promise<Redirect[]> {
    return new Promise<Redirect[]>((resolve,reject)=>{
      if(this.redirections){
        resolve(this.redirections);
      }
      this.api.get<RedirectResult>(this.wp.getVisitVarEndpoint('redirects')).then((redirectResult)=>{
        if(redirectResult && redirectResult.items){
          this.redirections = redirectResult.items;
        } else {
          this.redirections = [];
        }
        resolve(this.redirections);
      });
    })
  }

  setNotFound(message = 'not found'): this {
    if (this.response) {
      this.response.statusCode = 404
      this.response.statusMessage = message
    }
    this.router.navigate(['404']);
    return this
  }
}
